import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePostHog } from '@posthog/react'

export function PostHogPageView() {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (!posthog) return
    posthog.capture('$pageview', { path: location.pathname })
  }, [location.pathname, posthog])

  return null
}
